module.exports = __webpack_public_path__ + "static/media/play-solid.fddb8457.svg";